import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

import { CriteriaTextWrapper } from '../../SmartChoiceBreakDown.styles';

interface NotAMatchNoServiceDataTextTextProps {
  text: string;
  StartIcon?: React.ReactNode;
  EndIcon?: React.ReactNode;
}
export const NotAMatchNoServiceDataTextText = ({
  text,
  StartIcon,
  EndIcon,
}: NotAMatchNoServiceDataTextTextProps) => (
  <CriteriaTextWrapper
    data-testid={`not-a-match-text-${text}`}
    datatype="criteria-text-not-match"
  >
    <IconSymbol
      color="#C24E14"
      data-testid="no-service-data-icon"
      icon="search_off"
    />
    {StartIcon && <React.Fragment>{StartIcon}</React.Fragment>}
    {text && (
      <CriteriaTextWrapper data-testid="no-service-data-text">
        {text}
        {EndIcon && <React.Fragment>{EndIcon}</React.Fragment>}
      </CriteriaTextWrapper>
    )}
  </CriteriaTextWrapper>
);
